import { action } from '@/lib/api';

export const setAiContext = (context) => {
  action('uiSetAiContext', context);
};
